export type UrlStorageItem = {
  key: string
  value?: unknown
}

export const setUrlStorage = (items: UrlStorageItem[]) => {
  const preparedItems = items
    .map(({ key, value }) => ({
      key,
      value: tryStringifyOrUndefined(value),
    }))
    .filter(({ value }) => value !== undefined)
    .map(({ key, value }) => [key, value as string])
  const searchParams = new URLSearchParams(preparedItems)

  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}${preparedItems.length ? '?' : ''}${searchParams.toString()}`,
  )
}

export const getUrlStorage = (): UrlStorageItem[] => {
  const searchParams = new URLSearchParams(window.location.search)
  const storageItems = Array.from(searchParams.entries())
    .map(([key, value]) => ({ key, value: tryParseOrUndefined(value) }))
    .filter(({ value }) => value !== undefined)

  return storageItems
}

export const clearUrlStorage = () => {
  window.history.replaceState({}, '', `${window.location.pathname}`)
}

export const tryStringifyOrUndefined = (value: unknown) => {
  if (value === undefined) return undefined
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value)
  } catch {
    return undefined
  }
}

export const tryParseOrUndefined = (value: string) => {
  try {
    return JSON.parse(value)
  } catch {
    if (typeof value === 'string') {
      return value
    }
    return undefined
  }
}
